<template>
  <div id="app">
    <vx-router-view></vx-router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  methods: {},
  mounted() {
    app.simpleApp = this;
  },
  watch: {},
};
</script>

<style lang="scss">
// 绝对定位
@mixin position-absolute() {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
// 全局 根路由/页面 基础样式
#app {
  @include position-absolute;
  overflow: hidden;
}

// body .x3-router-page{
//     background-color: #F00;
// }
</style>